<template>
    <v-dialog max-width="800" v-model="isOpenNewTenantDialog">
        <v-card :loading="isLoadingTenants">
            <v-card-title primary-title>
                <div
                    v-if="$vuetify.breakpoint.xs"
                    class="primary--text text-overline ml-2"
                >
                    <v-icon left> mdi-card-account-details-outline </v-icon>
                    {{ formType == 'Edit' ? 'Editando' : 'Añadiendo' }}
                    Tenant
                </div>
                <div
                    v-else
                    class="font-weight-light primary--text text-h4 ml-2"
                >
                    <v-icon large left>
                        mdi-card-account-details-outline
                    </v-icon>
                    {{ formType == 'Edit' ? 'Editando' : 'Añadiendo' }}
                    Tenant
                </div>

                <v-spacer></v-spacer>
                <v-btn
                    @click="deleteSignature()"
                    :disabled="isLoadingTenants"
                    depressed
                    color="red"
                    dark
                >
                    Borrar Firma
                    <v-icon right> mdi-signature-image </v-icon>
                </v-btn>
            </v-card-title>
            <!-- <v-divider class="test mb-4"></v-divider> -->
            <v-card-text class="mt-2">
                <v-row no-gutters>
                    <v-col cols="12" class="p-4 mb-1">
                        <v-card elevation="0">
                            <!-- <v-row>
                                <v-col>
                                    <h4 class="mx-2 font-weight-light">
                                        Nombre del Distribuidor
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mx-2 mb-2"></v-divider> -->
                            <v-row>
                                <v-col align="center" md="9">
                                    <v-text-field
                                        :disabled="formType != 'Create'"
                                        v-model="form.name"
                                        label="Nombre"
                                        class="px-2"
                                        style="padding-bottom: 6px"
                                    ></v-text-field>
                                </v-col>
                                <v-col align="center" md="3">
                                    <v-switch
                                        v-model="form.enforce_mfa"
                                        label="Requerir MFA"
                                        :disabled="formType == 'Create'"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="p-4 mb-1">
                        <v-card elevation="0">
                            <!-- <v-row>
                                <v-col>
                                    <h4 class="mx-2 font-weight-light">
                                        Email del Distribuidor
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mx-2 mb-2"></v-divider> -->
                            <v-row>
                                <v-col align="center" cols="12">
                                    <v-text-field
                                        v-model="form.email"
                                        label="Email"
                                        class="px-2"
                                        style="padding-bottom: 6px"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="p-4 mb-1">
                        <v-card elevation="0">
                            <!-- <v-row>
                                <v-col>
                                    <h4 class="mx-2 font-weight-light">
                                        Tipo del Distribuidor
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mx-2 mb-2"></v-divider> -->
                            <v-row>
                                <v-col align="center" cols="12">
                                    <v-select
                                        :disabled="formType == 'Edit'"
                                        clearable
                                        class="py-n0 px-2"
                                        :items="['distributor', 'humanresource']"
                                        v-model="form.type"
                                        label="Tipo"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="p-4 mb-1">
                        <v-card elevation="0">
                            <!-- <v-row>
                                <v-col>
                                    <h4 class="mx-2 font-weight-light">
                                        Modo de Vista del Cliente
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mx-2 mb-2"></v-divider> -->
                            <v-row>
                                <v-col align="center" cols="12">
                                    <v-select
                                        clearable
                                        class="py-n0 px-2"
                                        :items="opciones ? opciones.distribuidor.clientViewMode : []"
                                        v-model="form.client_view_mode"
                                        label="Vista de clientes"
                                        item-text="human"
                                        item-value="encoded"
                                    >
                                    <template #selection="{ item }">
                                        <v-chip
                                            color="pink darken-2"
                                            class="white--text"
                                        >
                                            <v-icon>
                                                mdi-incognito
                                            </v-icon>
                                            {{ item.human }}
                                        </v-chip>
                                    </template>
                                </v-select>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="opciones">
                    <v-col cols="12" class="p-4">
                        <v-card elevation="0">
                            <!-- <v-row>
                                <v-col>
                                    <h4 class="mx-2 font-weight-light">
                                        Marcas Disponibles
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mx-2 mb-2"></v-divider> -->
                            <v-row>
                                <v-col align="center" cols="12">
                                    <v-select
                                        clearable
                                        chips
                                        multiple
                                        class="py-n0 px-2"
                                        :items="
                                            opciones.distribuidor
                                                .sellingCompanies"
                                        v-model="form.selling_companies"
                                        item-text="human"
                                        item-value="encoded"
                                        label="Marcas y segmento"
                                    >
                                        <template #selection="{ item }">
                                            <v-chip
                                                color="pink darken-2"
                                                class="white--text"
                                            >
                                                <v-icon>
                                                    mdi-tag
                                                </v-icon>
                                                {{ item.human }}
                                            </v-chip>
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <div 
                    id="exportForm"
                    @drop="handleFileDrop"
                    class="mt-4"
                >
                    <v-icon 
                        v-if="form.signature && form.signature.length" 
                        large 
                        color="red" 
                        class="deleteBtn"
                        @click="form.signature = null"
                        style="z-index: 1;"
                        >mdi-delete</v-icon>
                    <v-container
                        fluid 
                        fill-height
                        class="d-flex justify-center align-center"
                    >
                        <div v-if="!form.signature || !form.signature.length" class="d-flex flex-column">
                            <v-icon size="100"> mdi-account-credit-card-outline </v-icon>
                            <div class="text-center overline font-weight-light">
                                Arrastre el archivo con la firma o sello o haga click para abrir el explorador de archivos
                            </div>
                        </div>
                        <div v-else class="d-flex justify-center">
                            <v-badge class="" color="error" icon="mdi-arrow-up-bold" overlap>
                                <v-icon color="green accent-1" size="100">
                                    mdi-file-document-edit-outline
                                </v-icon>
                                <div class="overline">
                                    <small>{{ form.signature[0].name.slice(0, 15) }}</small>
                                </div>
                                <div class="grey--text overline">
                                    {{ (form.signature[0].size / (1024 * 1024)).toFixed(1) }} MB
                                </div>
                            </v-badge>
                        </div>
                    </v-container>
                    <input
                        :style="getTopMargin()"
                        type="file"
                        name="file-input"
                        @change="handleFileInput"
                    />
                </div>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-col cols="12" md="4" class="ml-auto">
                    <div
                        :class="
                            $vuetify.breakpoint.smAndDown
                                ? 'd-block'
                                : 'd-flex justify-end'"
                    >
                        <v-btn
                            depressed
                            :disabled="isLoadingTenants"
                            :width="$vuetify.breakpoint.smAndDown ? '100%' : ''"
                            :class="$vuetify.breakpoint.smAndDown ? 'mb-1' : ''"
                            color="success"
                            dark
                            @click="createTenant()"
                            v-if="formType == 'Create'"
                        >
                            <v-icon left> mdi-content-save </v-icon>
                            crear
                        </v-btn>
                        <v-btn
                            depressed
                            :disabled="isLoadingTenants"
                            :width="$vuetify.breakpoint.smAndDown ? '100%' : ''"
                            :class="$vuetify.breakpoint.smAndDown ? 'mb-1' : ''"
                            color="warning"
                            dark
                            @click="editTenant()"
                            v-if="formType == 'Edit'"
                        >
                            <v-icon left> mdi-pencil</v-icon>
                            editar
                        </v-btn>
                        <v-btn
                            depressed
                            text
                            color="red"
                            :width="$vuetify.breakpoint.smAndDown ? '100%' : ''"
                            :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''"
                            @click="isOpenNewTenantDialog = false"
                        >
                            cerrar
                        </v-btn>
                    </div>
                </v-col>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'newTenantForm',
    data: () => ({
        allowedExtensions: ['jpg', 'jpeg', 'png'],
    }),
    computed: {
        isOpenNewTenantDialog: {
            get() {
                return this.$store.state.tenantManagement.newTenant.isOpen;
            },
            set(val) {
                this.$store.commit(
                    'tenantManagement/isOpenNuevaCuentaDialogo',
                    val
                );
            },
        },
        form: {
            get() {
                return this.$store.state.tenantManagement.newTenant.form;
            },
            set(val) {
                this.$store.commit('tenantManagement/newTenant', val);
            },
        },
        formType: {
            get() {
                return this.$store.state.tenantManagement.newTenant.formType;
            },
            set(val) {
                this.$store.commit('tenantManagement/newTenant', val);
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        ...mapState('tenantManagement', {
            isLoadingTenants: (state) => state.isLoadingTenants,
        }),
    },
    methods: {
        getTopMargin() {
            if (this.$vuetify.breakpoint.smAndDown) {
                return this.opciones ? 'top: 490px' : 'top: 400px';
            } else {
                return this.opciones ? 'top: 530px' : 'top: 380px';
            }
        },
        deleteSignature() {
            let deleteObj = {
                id: this.form.id,
                field: 'signature'
            };
            this.$store.dispatch('tenantManagement/deleteTenantFile', deleteObj);
        },
        handleFileDrop(e) {
            let droppedFiles = e.dataTransfer.files;
            let fileExtention = droppedFiles[0].name.split('.').pop();

            if (!droppedFiles) return;
            else {
                this.form.signature = [];

                if (this.allowedExtensions.includes(fileExtention)) {
                    this.form.signature.push(droppedFiles[0]);
                } else {
                    this.$store.dispatch(
                        'util/showStatusSnackBar',
                        {
                            statusType: 'error',
                            message:
                                'El archivo ' +
                                droppedFiles[0].name +
                                ' no es del tipo correcto',
                        },
                        { root: true }
                    );
                }

                this.$forceUpdate();
            }
        },
        handleFileInput(e) {
            let files = e.target.files;
            let fileExtention = files[0].name.split('.').pop();

            if (!files) return;
            else {
                this.form.signature = [];

                if (this.allowedExtensions.includes(fileExtention)) {
                    this.form.signature.push(files[0]);
                } else {
                    this.$store.dispatch(
                        'util/showStatusSnackBar',
                        {
                            statusType: 'error',
                            message:
                                'El archivo ' +
                                files[0].name +
                                ' no es del tipo correcto',
                        },
                        { root: true }
                    );
                }
                console.log(this.form.signature);

                this.$forceUpdate();
            }
        },
        createTenant() {
            this.$store.commit('tenantManagement/isLoadingTenants', true);
            this.$store.dispatch('tenantManagement/createTenant').then(() => {
                this.$store.commit('tenantManagement/isLoadingTenants', false);
                this.$store.commit(
                    'tenantManagement/openNewTenantDialog',
                    false
                );
            });
        },
        editTenant() {
            this.$store.commit('tenantManagement/isLoadingTenants', true);
            this.$store.dispatch('tenantManagement/editTenant').then(() => {
                this.$store.commit('tenantManagement/isLoadingTenants', false);
                this.isOpenNewTenantDialog = false;
            });
        },
    },
};
</script>

<style scoped>
.deleteBtn {
    display: flex;
    justify-content: flex-end;
    position: relative;
    padding: 10px;
}

#exportForm input {
    cursor: pointer;
    opacity: 0;
    width: 100%;
    height: 180px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>